import {
  mapActions,
  mapGetters
} from 'vuex';
import GestionCategoriesI18n from './GestionCategories.i18n.js';

export default {

  components: {},

  props: {},

  computed: {
    ...mapGetters(['categories', 'categoriesLoading']),
    modalTitle() {
      if (this.creationMode === 'create') {
        return "Créer une nouvelle catégorie"
      } else {
        return "Modifier une catégorie"
      }
    }
  },

  data() {
    return {
      // Cat
      currentCategoryName: '',
      currentCategoryOrder: 1,
      currentCategoryId: 0,
      currentDisplayInHome: false,
      creationMode: 'create'
    };
  },

  watch: {},

  methods: {
    ...mapActions(['getCategories', 'createCategorie', 'updateCategorie', 'deleteCategorie']),
    /**
     * Function to manage categories
     */
    createCategory() {
      if (this.creationMode === 'create') {
        const category = {
          nom: this.currentCategoryName,
          ordre: this.currentCategoryOrder
        }
        this.createCategorie(category).then(res => {
          this.getCategories()
          this.hideModalAddCategory()
        }).catch(err => {
          console.log(err)
        })
      } else {
        const category = {
          id: this.currentCategoryId,
          nom: this.currentCategoryName,
          ordre: this.currentCategoryOrder
        }
        this.updateCategorie(category).then(res => {
          this.getCategories()
          this.hideModalAddCategory()
        }).catch(err => {
          console.log(err)
        })
      }
    },
    removeCategory() {
      const category = {
        id: this.currentCategoryId,
      }
      this.deleteCategorie(category).then(res => {
        console.log(res)
        this.getCategories()
        this.hideModalDeleteCategory()
      }).catch(err => {
        console.log(err)
      })
    },
    showModalUpdateCategory(pCategoryId, pCategoryName, pCategoryOrder) {
      this.currentCategoryId = pCategoryId
      this.currentCategoryName = pCategoryName
      this.currentCategoryOrder = pCategoryOrder
      this.creationMode = 'update'
      this.$refs['modal-add-category'].show()
    },
    showModalAddCategory() {
      this.currentCategoryId = ''
      this.currentCategoryName = ''
      this.currentCategoryOrder = 1
      this.creationMode = 'create'
      this.$refs['modal-add-category'].show()
    },
    hideModalAddCategory() {
      this.$refs['modal-add-category'].hide()
    },
    showModalDeleteCategory(pId) {
      this.currentCategoryId = pId
      this.$refs['modal-delete-category'].show()
    },
    hideModalDeleteCategory() {
      this.$refs['modal-delete-category'].hide()
    }
  },

  mounted() {
    this.getCategories().then(res => {

    }).catch(err => {
      console.log(err)
    })

  },

  i18n: GestionCategoriesI18n,

};